<template lang="html">
  <div>
    <div v-show="!edit">
      <v-container class="pt-0">
        <v-row>
          <v-col cols="4">
            <span class="font-weight-medium">Course Name:</span>
          </v-col>
          <v-col cols="8">
            {{ course.name }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <span class="font-weight-medium">Description:</span>
          </v-col>

          <v-col cols="8">
            {{ course.description }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <span class="font-weight-medium">Classroom Type:</span>
          </v-col>

          <v-col cols="8">
            {{ classroomTypeName }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <span class="font-weight-medium">Course Category:</span>
          </v-col>

          <v-col cols="8">
            {{ courseCategoryName }}
          </v-col>
        </v-row>

        <!-- Temporary DISABLE -->
        <!-- <v-row>
          <v-col cols="4">
            <span class="font-weight-medium">Awards:</span>
          </v-col>

          <v-col cols="8">
            <v-row
              v-for="award in course.awards"
              :key="award.id"
              class="d-flex"
            >
              <v-img
                :src="award.image_url"
                max-height="42"
                max-width="42"
              />
              <span class="my-auto ml-2">{{ award.name }}</span>
            </v-row>
          </v-col>
        </v-row> -->

        <!-- <v-row no-gutters>
          <v-col cols="4">
            <span class="font-weight-medium">Skills:</span>
          </v-col>

          <v-col cols="8">
            <v-row
              v-for="skill in course.skill_levels"
              :key="skill.id"
              no-gutters
            >
              <v-col cols="1">
                <v-img
                  :src="skill.skill.image_url"
                  max-height="42"
                  max-width="42"
                />
              </v-col>
              <v-col
                cols="11"
                class="ml-n9"
              >
                <div class="font-weight-bold">
                  {{ skill.skill.name }}
                </div>
                <div>{{ skill.description }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row> -->
      </v-container>
    </div>

    <form v-show="edit">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              v-validate="'required'"
              :error-messages="errors.collect('name')"
              data-vv-name="name"                
              label="Course Name"
              :disabled="!edit"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="mb-0 py-0"
          >
            <v-autocomplete
              v-model="courseCategory"
              v-validate="'required'"
              :disabled="!edit"
              :loading="loading"
              :items="courseCategories"
              label="Select Course Category"
              data-vv-name="promiser_uid"
              data-vv-as="Course Category"
              hide-selected
              item-text="name"
              item-value="id"
              :error-messages="errors.collect('promiser_uid')"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            lg="12"
          >
            <v-textarea
              v-model="description"
              v-validate="'required'"
              :disabled="!edit"
              data-vv-name="description"
              data-vv-as="Description"
              :error-messages="errors.collect('description')"
              solo
              name="input-7-4"
              label="Description"
              placeholder="Course description"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="mb-0 py-0"
          >
            <v-autocomplete
              v-model="classroomType"
              v-validate="'required'"
              :disabled="!edit"
              :loading="loading"
              :items="classroomTypes"
              label="Select Classroom Type"
              data-vv-name="classroom_type_id"
              data-vv-as="Classroom Type"
              hide-selected
              item-text="name"
              item-value="id"
              :error-messages="errors.collect('classroom_type_id')"
            />
          </v-col>
        </v-row>

        <!-- Temporary DISABLE -->
        <!-- <v-row>
          <v-col
            cols="12"
            class="mb-0 py-0"
          >
            <v-autocomplete
              v-model="award"
              :disabled="!edit"
              :items="awards"
              label="Awards Completing Course"
              hide-selected
              item-text="name"
              item-value="id"
              multiple
              chips
              deletable-chips
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(award,data.item)"
                >
                  <v-avatar left>
                    <v-img :src="data.item.image_url" />
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>

              <template v-slot:item="data">
                <v-list-item-avatar>
                  <img :src="data.item.image_url">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name" />
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row> -->

        <!-- <v-row>
          <v-col
            cols="12"
            class="mb-0 py-0"
          >
            <v-autocomplete
              v-model="skill"
              :disabled="!edit"
              :loading="loading"
              :items="skills"
              label="Skills Completing Course"
              hide-selected
              item-text="name"
              item-value="level.id"
              multiple
              chips
              deletable-chips
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(skill,data.item)"
                >
                  <v-avatar left>
                    <v-img :src="data.item.image_url" />
                  </v-avatar>
                  <span class="text-truncate">
                    {{ data.item.level.description }}
                  </span>
                </v-chip> 
              </template>

              <template v-slot:item="data">
                <v-list-item-avatar>
                  <img :src="data.item.image_url">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name" />
                  <v-list-item-subtitle v-html="data.item.level.description" />
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col
            cols="12"
            class="mb-0 py-0"
          >
            <helper-image-input  
              v-model="image" 
              :max-size-in-mb="2"
              data-vv-name="image"
              field-name="image"
              accept-type=".jpg,.jpeg,.png"            
            >          
              <div 
                slot="activator"
                class="mb-2"
              >   
                <v-btn                    
                  :disabled="progressing"
                  class="mx-2"    
                >
                  Add Image
                </v-btn>
                <span>
                  {{ image ? image.imageFile.name : 'No file chosen (.jpg/.png only)' }}
                </span>
              </div>
            </helper-image-input>
            <span class="red--text text--lighten-1">{{ errors.first('image') }}</span>
          </v-col>
        </v-row>
      </v-container>
    </form>

    <v-card-actions v-if="$hasPermissionTo(['update courses'])">
      <v-spacer />
      <div>
        <v-btn
          v-if="!edit"
          color="info"          
          @click="edit = true"
        >
          Edit
        </v-btn>
        <v-btn
          v-if="edit"
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn
          v-if="edit"
          :loading="progressing"
          class="mx-2 font-weight-light"
          color="success"          
          @click="submitForm"
        >
          Save Changes
        </v-btn>
      </div>
    </v-card-actions>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {
      HelperImageInput: () => import('@/components/helper/ImageInput'),
    },
    inject: ['$validator'],
    props: {  
      courseId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        name: null,
        description: null,
        classroomTypes: [],
        courseCategories: [],
        awards: [],
        classroomType: null,
        courseCategory: null,
        progressing: false,
        edit: false,
        loading: false,
        image: null,
        award: [],
        skills: [],
        skill: [],
      }
    },
    computed: {
      courseCategoryName () {
        return (this.courseCategories.find(currentCategory => {
          return currentCategory.id === this.courseCategory
        }) || {}).name || ''
      },
      classroomTypeName () {
        return (this.classroomTypes.find(currentType => {
          return currentType.id === this.classroomType
        }) || {}).name || ''
      },
      ...mapGetters({
        course: 'course/currentCourse',
      }),
    },
    watch: {
      course: {
        immediate: true,
        handler (newValue, oldValue) {
          this.award = []
          this.skill = []
          Promise.all([
            this.$api.awards().list(),
            this.$api.skills().list(['levels']),
          ])
            .then(([awards, skills]) => {
              let temp = []
          
              this.awards = awards.data
            
              skills.data.map((skill, i) => {
                skill.levels.forEach((level, index) => {
                  temp.push({ 
                    category: skill.category,
                    id: i * 5 + index + 1,
                    image_path: skill.image_path,
                    image_url: skill.image_url,
                    level_counts: skill.level_count,
                    name: skill.name,
                    skill_category_id: skill.skill_category_id, 
                    level: { 
                      description: skill.levels[index].description,
                      id: skill.levels[index].id,
                      level: skill.levels[index].level,
                      skill_id: skill.levels[index].skill_id,
                    },
                  })
                })  
              })
              this.skills = temp
            })

          if (newValue) {
            this.name = newValue.name          
            this.description = newValue.description
            this.classroomType = newValue.classroom_type_id
            this.courseCategory = newValue.course_category_id

            newValue.awards.map(award => {
              this.award.push(award.id)
            })    
            newValue.skill_levels.map(skillLevel => {
              this.skill.push(skillLevel.id)
            })

            this.$validator.reset()
          }
        },
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.courses().update(this.courseId, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$snack({ message: 'Updated' })
                  this.$emit('updated')
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
                this.edit = false
              })
          })
      },
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.classroomTypes().list(),
          this.$api.courseCategories().list(),
        ])
          .then(([classroomTypes, courseCategories]) => {
            this.classroomTypes = classroomTypes.data
            this.courseCategories = courseCategories.data
          })
          .then(() => {
            this.loading = false
          })                 
      },
      prepareFormData () {
        if (!this.image) {
          return {
            'name': this.name,
            'description': this.description,
            'classroom_type_id': this.classroomType,
            'course_category_id': this.courseCategory,
            'award_ids': this.award,
            'skill_level_ids': this.skill,
          }
        }

        this.image.formData.append('name', this.name)
        this.image.formData.append('description', this.description)
        this.image.formData.append('classroom_type_id', this.classroomType)
        this.image.formData.append('course_category_id', this.courseCategory)
        this.image.formData.append('award_ids', this.award)
        this.image.formData.append('skill_level_ids', this.skill)

        return this.image.formData
      },   
      remove (array, item) {
        const index = array.indexOf(item.id)
        if (index >= 0) array.splice(index, 1)
      },
    },
  }
</script>

<style scoped>
.text-truncate{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
